<div class="distribution-analysis-container" *ngIf="isAuthorized">
    <div class="row-layout-track">
        <div class="largecard-layout-box__100pct">
            <div class="row-layout-track">
                <div class="distribution-analyze-title-are largecard-layout-box__80pct">{{ data.clientKPIDescription }}</div>
                <div [ngStyle]="{ color: saveMessageColor }" class="save-message-container largecard-layout-box__20pct">{{ saveMessage }}</div>
            </div>

            <div class="distribution-analysis-area row-layout-track">
                <div class="largecard-layout-box__50">
                    <large-card [largeCardInteriorOptions]="histogramCard"></large-card>
                </div>
                <div class="largecard-layout-box__20pct">
                    <div class="calculated-metric-area">
                        <div class="distribution-sub-title">Calculated metrics</div>
                        <table class="metric-data-table">
                            <tr class="metric-table-title">
                                <th class="metric-description">Metric</th>
                                <th class="metric-value">Value</th>
                            </tr>
                            <tr>
                                <td class="metric-description">Mean (<i>μ</i>)</td>
                                <td class="metric-value">{{ metrics.mean }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Median</td>
                                <td class="metric-value">{{ metrics.median }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Std (<i>σ</i>)</td>
                                <td class="metric-value">{{ metrics.std }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Min</td>
                                <td class="metric-value">{{ metrics.min }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Max</td>
                                <td class="metric-value">{{ metrics.max }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Count</td>
                                <td class="metric-value">{{ metrics.count }}</td>
                            </tr>
                            <tr>
                                <td class="metric-description">Outliers</td>
                                <td class="metric-value">{{ metrics.outlierCount }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="largecard-layout-box__30pct">
                    <large-card [largeCardInteriorOptions]="boxplotCard"></large-card>
                </div>
            </div>      
        </div>
        <div class="updated-data-container row-layout-track">
            <div class="largecard-layout-box__100pct">
                <div class="row-layout-track">
                    <div class="distribution-sub-title largecard-layout-box__40pct">Configuration values</div>
                    <div class="largecard-layout-box__60pct">
                        <div class="submit-button-area">
                            <button mat-button mat-raised-button
                                    *ngFor="let btn of buttonOptions"
                                    (click)="distributionButtonClick(btn.id)"
                                    [disabled]="btn.disabled"
                                    class="{{ btn.class }} button-style"
                            >{{ btn.name }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="largecard-layout-box__100pct">
            <!-- TODO: Remove kendo-grid and use regular table  -->
                <kendo-grid
                        [loading]="loading"
                        [data]="gridData"
                        [sortable]="false"
                        [scrollable]="'none'"
                        class="lg-kendo-grid"
                >
                    <kendo-grid-column
                            field="status"
                            title="Status"
                            [width]="85"
                            [headerStyle]="{ 'text-align': 'center', 'padding': '5px'  }"
                            [style]="{ 'text-align': 'center', 'padding': '5px'  }"
                    ></kendo-grid-column>
                    <kendo-grid-column
                            field="range1End"
                            title="Poor"
                            [width]="120"
                            [headerStyle]="{ 'background-color': '#fddbdb', 'text-align': 'center', 'padding': '5px' }"
                            [style]="{ 'text-align': 'center', 'background-color': '#fddbdb',  'padding': '5px' }"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span style="padding-right: 2px">
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&le;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&ge;</span>
                    </span>
                            <span>{{
                                _reusableFunctions.formatNumber(dataItem.range1End, dataItem.precision, dataItem.kpiFormat)
                                }}</span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column
                            field="range2Start"
                            title="Fair"
                            [width]="220"
                            [headerStyle]="{ 'background-color': '#fff9e7', 'text-align': 'center', 'padding': '5px'  }"
                            [style]="{ 'text-align': 'center', 'background-color': '#fff9e7', 'padding': '5px'  }"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span>
                        <i
                                class="fas fa-exclamation-circle ng-star-inserted form-error"
                                *ngIf="dataItem.range2StartError"
                        ></i
                        ></span>
                            <span *ngIf="rowIndex > 0">
                        <input
                                class="text-box-style"
                                matInput
                                [(ngModel)]="dataItem.range2Start"
                                type="number"
                                (change)="updatingToValueChange('range2Start', 'range1End', 1)"
                        />
                    </span>
                            <span *ngIf="rowIndex === 0">{{
                                _reusableFunctions.formatNumber(dataItem.range2Start, dataItem.precision, dataItem.kpiFormat)
                                }}
                    </span>
                            <span style="padding-left: 9px; padding-right: 7px">-</span>
                            <span>{{
                                _reusableFunctions.formatNumber(dataItem.range2End, dataItem.precision, dataItem.kpiFormat)
                                }}</span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column
                            field="range3Start"
                            title="Good"
                            [width]="340"
                            [headerStyle]="{ 'background-color': '#e0f3f3', 'text-align': 'center', 'padding': '5px'  }"
                            [style]="{ 'text-align': 'center', 'background-color': '#e0f3f3', 'padding': '5px'  }"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span>
                        <i
                                class="fas fa-exclamation-circle ng-star-inserted form-error"
                                *ngIf="dataItem.range3StartError || dataItem.range3EndError"
                        ></i>
                    </span>

                            <span *ngIf="rowIndex > 0">
                        <input class="text-box-style"
                               matInput
                               [(ngModel)]="dataItem.range3Start"
                               type="number"
                               (change)="updatingToValueChange('range3Start', 'range2End', 3)"
                        />
                    </span>
                            <span *ngIf="rowIndex === 0">{{
                                _reusableFunctions.formatNumber(dataItem.range3Start, dataItem.precision, dataItem.kpiFormat)
                                }}
                    </span>

                            <span
                                    style="
                            font-size: 16px;
                            padding-left: 10px;
                            padding-right: 8px;
                            text-align: center;
                        "
                            >
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than"
                        >&gt;</span
                        >
                    </span>
                            <span *ngIf="rowIndex === 0">{{
                                _reusableFunctions.formatNumber(dataItem.target, dataItem.precision, dataItem.kpiFormat)
                                }}
                    </span>
                            <span *ngIf="rowIndex > 0">
                        <input
                                class="text-box-style"
                                matInput
                                [(ngModel)]="dataItem.target"
                                type="number"
                                (change)="updatingToValueChange('target', null, 4)"
                        />
                    </span>

                            <span
                                    style="
                            font-size: 16px;
                            padding-left: 8px;
                            padding-right: 10px;
                            text-align: center;
                        "
                            >
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than"
                        >&gt;</span
                        >
                    </span>
                            <span *ngIf="rowIndex > 0">
                        <input class="text-box-style"
                               matInput
                               [(ngModel)]="dataItem.range3End"
                               type="number"
                               (change)="updatingToValueChange('range3End', 'range4Start', 5)"
                        />
                    </span>
                            <span *ngIf="rowIndex === 0">{{
                                _reusableFunctions.formatNumber(dataItem.range3End, dataItem.precision, dataItem.kpiFormat)
                                }}
                    </span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column
                            field="range4Start"
                            title="Very Good"
                            [width]="220"
                            [headerStyle]="{ 'background-color': '#f7efff', 'text-align': 'center', 'padding': '5px' }"
                            [style]="{ 'text-align': 'center', 'background-color': '#f7efff', 'padding': '5px'  }"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span>
                        <i
                                class="fas fa-exclamation-circle ng-star-inserted form-error"
                                *ngIf="dataItem.range4EndError"
                        ></i
                        ></span>
                            <span>{{
                                _reusableFunctions.formatNumber(dataItem.range4Start, dataItem.precision, dataItem.kpiFormat)
                                }}</span>
                            <span style="padding-left: 7px; padding-right: 9px">-</span>

                            <span *ngIf="rowIndex > 0">
                        <input class="text-box-style"
                               matInput
                               [(ngModel)]="dataItem.range4End"
                               type="number"
                               (change)="updatingToValueChange('range4End', 'range5Start', 7)"
                        />
                    </span>
                            <span *ngIf="rowIndex === 0">{{
                                _reusableFunctions.formatNumber(dataItem.range4End, dataItem.precision, dataItem.kpiFormat)
                                }}
                    </span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column
                            field="range5Start"
                            title="Excellent"
                            [width]="120"
                            [headerStyle]="{ 'background-color': '#f3f9ed', 'text-align': 'center', 'padding': '5px' }"
                            [style]="{ 'background-color': '#f3f9ed', 'text-align': 'center', 'padding': '5px' }"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span>{{
                        _reusableFunctions.formatNumber(dataItem.range5Start, dataItem.precision, dataItem.kpiFormat)
                        }}</span>
                            <span style="padding-left: 2px">
                        <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&le;</span>
                        <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&ge;</span> 
                    </span>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div> 
</div>
